<!-- 解决方案详情 -->
<template>
    <div class="solution-details-container">
      <roof-search :middleContent="false" :rightContent="false" :placeholder="true"  v-show="isShowNav"></roof-search>
      <div class="slider-container">
        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
          <van-swipe-item v-for="(item,index) in img_url" :key="index" @click="previewImg(index)">
            <van-image class="slider-img" fit="cover" :src="cdnUrl+item"/>
          </van-swipe-item>
        </van-swipe>
      </div>
      <div class="solution-content">
        <div class="solution-title van-multi-ellipsis--l2">{{title}}</div>
      </div>
      <!-- 标签栏 -->
      <div class="tabs-container">
        <van-tabs v-model="tabsActive"
                  animated
                  :color="tabsColor"
                  :title-active-color="titleActiveColor"
                  :title-inactive-color="titleInactiveColor"
                  @change="tabsChange"
                  line-width="100"
                  line-height="2">
          <van-tab title="方案介绍">
            <introduction :introduction="desc"></introduction>
            <scheme :solution="solution"></scheme>
          </van-tab>
          <van-tab :title="id == 48?'应用文献':'产品推荐'">
            <!-- <scheme :solution="solution"></scheme> -->
            <recommend :recommendList="recommendList"></recommend>
          </van-tab>
          <van-tab title="方案资料" v-if="recommendList.length != 0">
            <!-- <recommend :recommendList="recommendList"></recommend> -->
            <product-material :productMaterial="productMaterial" :id="id" @videoChange="videoChange"></product-material>
          </van-tab>
        </van-tabs>
        <!-- 视频播放 -->
      <van-overlay :show="showVideo" @click="hideVideoMsg" class="van-overlayes">
        <div class="dplayer-containers" @click.stop>
          <div id="dplayer" class="video-container"></div>
        </div>
      </van-overlay>
      </div>
    </div>
</template>

<script>
import roofSearch from '@/components/roof-search'
import introduction from './components/introduction'
import scheme from './components/scheme'
import recommend from './components/recommend'
import productMaterial from '../product/components/product-material.vue'
import details from './mixins/details'
import { getSolutionDetails, getPreviewDetails } from '@/api/solution'
import { ImagePreview } from 'vant'
import { wxShare } from '@/libs/wxjssdk'
import DPlayer from 'dplayer'
export default {
    mixins: [details],
    data () {
        return {
            cdnUrl: this.$config.baseUrl.cdnUrl,
            isShowNav: false,
            is_preview: false,
            tabsActive: 0, // 标签栏选中的下标
            tabsColor: '#005b9f', // 标签栏背景色
            titleActiveColor: '#005b9f', // 标签栏标题栏选中颜色
            titleInactiveColor: '#9d9d9d', // 标签栏标题默认颜色
            id: '',
            dp: {},
            title: '',
            shareDesc: '',
            img_url: [],
            desc: '',
            solution: [],
            cover_img_url: '',
            recommendList: [],
        }
    },
    components: {
        roofSearch,
        introduction,
        scheme,
        recommend,
        productMaterial
    },
    created () {
        const query = this.$route.query
        this.id = query.id || ''
        this.isShowNav = query.isShowNav || false
        this.is_preview = query.is_preview || false
        this.$toast.loading({
            message: '加载中...',
            forbidClick: true,
            duration: 0
        })
        // this.getProductDetailsPort()
        // 获取记录的tabs 1.分享回来的tab 2.产品跳转走的tab
        let tabs = this.$route.query.tabs ? this.$route.query.tabs : Number(window.localStorage.getItem("solutionTabs"));
        this.$nextTick(() => {
          this.tabsActive = +tabs
          switch (this.tabsActive) {
            case 0:
              this.shareDesc = '方案介绍'
              break;
            case 1:
              this.shareDesc = '产品推荐'
              break;
            case 2:
              this.shareDesc = '方案资料'
              break;
            default:
              this.shareDesc = '方案介绍'
              this.tabsActive = 0
          }
        })
        if (this.is_preview) {
            // 预览二维码进来的
            this.getPreviewPort()
        } else {
            this.getSolutionDetailsPort()
        }
    },
    mounted () {
      // console.log('url的数据',this.$route.query.tabs);
      // 获取记录的tabs 1.分享回来的tab 2.产品跳转走的tab
      let tabs = this.$route.query.tabs ? this.$route.query.tabs : Number(window.localStorage.getItem("solutionTabs"));
      // 删除设置的产品跳转走的tabs
      window.localStorage.removeItem("solutionTabs");
      this.$nextTick(() => {
          this.tabsActive = +tabs
      })
    },
    methods: {
      dplayerOption (videoUrl, pic) {
          const dp = new DPlayer({
              container: document.getElementById('dplayer'),
              // screenshot: false,
              autoplay: true,
              video: {
                  url: videoUrl || '',
                  pic: pic || '',
                  thumbnails: 'thumbnails.jpg'
              }
              // subtitle: {
              //   url: 'webvtt.vtt'
              // }
              // danmaku: {
              //   id: 'demo',
              //   api: 'https://api.prprpr.me/dplayer/'
              // }
          })
          this.dp = dp
        },
         // 隐藏video蒙版
        hideVideoMsg () {
            this.showVideo = false
            this.dp.pause()
            this.dp.fullScreen.cancel('web') // 退出全屏
        },
        sharePage () {
          
            const params = {
                title: this.title, // 分享标题
                desc: this.shareDesc, // 分享描述
                link: `${window.location.href.split('#')[0]}#/solutionDetails?id=${this.id}&isShowNav=true&tabs=${this.tabsActive}`, // 分享链接
                // link: `${window.location.href.split('#')[0]}#/solutionList?solution_id=${this.id}&isShowNav=true&tabs=${this.tabsActive}`, // 分享链接
                imgUrl: `${this.cdnUrl}${this.cover_img_url}` // 分享图标
            }
            // console.log('分享描述',this.shareDesc,'分享链接',params.link,'图片',params.imgUrl,'默认的tabs',this.tabsActive);
            wxShare(params)
        },
        // 单击预览图片
        previewImg (index) {
            var wrapImgs = []
            this.img_url.map((val) => {
                wrapImgs.push(this.cdnUrl + val)
            })
            ImagePreview({
                images: wrapImgs,
                startPosition: index
            })
        },
        tabsChange (val) {
          // console.log('tab的id',val);
          switch (val) {
          case 0:
            this.shareDesc = '方案介绍'
            break;
          case 1:
            this.shareDesc = '产品推荐'
            break;
          case 2:
            this.shareDesc = '方案资料'
            break;
          default:
            this.shareDesc = '方案介绍'
        }
        this.sharePage()
        // switch (val) {
        //   case 0:
        //     document.title = '方案简介'
        //     break
        //   case 1:
        //     document.title = '解决方案'
        //     break
        //   case 2:
        //     document.title = '产品推荐'
        //     break
        // }
        },
        // 处理产品推荐数据
        formatRecommendData (recommend) {
            if (recommend.length !== 0) {
                recommend.map((val) => {
                    if (val.recommends) {
                        val.recommends.map((item) => {
                            item.desc = JSON.parse(item.desc || '[]')
                        })
                    }
                })
            }
            console.log('打印下载', recommend)
            this.recommendList = recommend

        // console.log('recommend', recommend)
        },
        /** 网络请求 **/
        // 获取详情数据
        getSolutionDetailsPort () {
            getSolutionDetails({ id: this.id }).then(res => {
                this.$toast.clear()
                console.log('解决方案的详情',res);
                if (res.errCode === 0) {
                   this.productMaterial.video = res.data.video || []
                    this.productMaterial.pdf = res.data.pdf || []
                    var data = res.data
                    this.cover_img_url = data.cover_img_url || ''
                    this.title = data.title || ''
                    this.img_url = JSON.parse(data.img_url || '[]')
                    this.desc = JSON.parse(data.desc || '[]')
                    this.solution = JSON.parse(data.solution || '[]')
                    this.formatRecommendData(data.recommend)
                    document.title = this.title
                    this.sharePage()
                    console.log(data)
                } else {
                    this.$toast(res.errMsg)
                }
            }).catch(err => {
                console.log('获取解决方案详情失败', err)
                this.$toast('获取解决方案详情接口出错，请稍后重试')
            })
        },
        // 获取预览接口的数据详情
        getPreviewPort () {
            getPreviewDetails({ id: this.id }).then(res => {
                this.$toast.clear()
                if (res.errCode === 0) {
                    console.log('获取预览的数据', res)
                    var data = res.data.params
                    this.cover_img_url = data.cover_img_url || ''
                    this.title = data.title || ''
                    this.img_url = JSON.parse(data.img_url || '[]')
                    this.desc = JSON.parse(data.desc || '[]')
                    this.solution = JSON.parse(data.solution || '[]')
                    this.formatRecommendData(data.recommend)
                    document.title = '预览效果'
                    this.sharePage()
                    console.log(data)
                } else {
                    this.$toast(res.errMsg)
                }
            })
        }
    }
}
</script>

<style lang="scss">
.van-overlayes{
  z-index: 9999;
  .dplayer-containers{
    position: absolute;
    top: 45%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 90%;
    margin: 0 auto;
    .video-container{
      width: 100%;
      height: 280px;
    }
  }
}
.solution-details-container{
  background: #fff;
  .slider-container{
    width: 100%;
    height: rem(160);
    background: #cfcfcf;
    .my-swipe{
      height: 100%;
      .slider-img{
        width: 100%;
        height: 100%;
      }
    }
  }
  .solution-content{
    padding: 0 rem(20);
    .solution-title{
      margin: rem(13) 0;
      font-size: rem(15);
      font-weight: 500;
      color: #2C2C2C;
      line-height: rem(25);
      position: relative;
      padding-left: rem(13);
      &:after{
        content: '';
        width: rem(7);
        height: rem(17);
        background: $base-color;
        position: absolute;
        top: rem(5);
        left: 0;
      }
    }
  }
  .tabs-container{
    .van-tab{
      font-size: 15px;
    }
    .van-tab--active{
      font-weight: bold;
    }
    .van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after{
      /*border-width: 0;*/
      /*border-bottom: 1px solid ;*/
      border-top: 0 solid;
      border-bottom: 1px solid #eaeaea;
    }
  }
}
</style>
